import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImeiCheckComponent } from './imei-check.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '', component: ImeiCheckComponent,
      },
    ])],
  exports: [RouterModule]
})
export class imeiCheckRoutingModule { }

/**
 * User redirection if access to user adding screen is not allowed
 */
export function userAddRedirectTo() {
  console.log('Access Denied - insufficient rights for this function');
  // Helper.broadcast('Access Denied - insufficient rights for this function');
  return '/error500';
}
